import LogRocket from 'logrocket';

const sanitizedActions = new Set([]);

export const stateSanitizer = (state) => ({ ...state });
export const actionSanitizer = (action) => (sanitizedActions.has(action.type) ? null : action);

export default LogRocket.reduxMiddleware({ stateSanitizer, actionSanitizer });
